// api should be here
import { http } from '@/utils/http';
import qs from 'qs';
// 活动api baseurl
const urlPrefix = 'vote/2023project/q4/2023regimen/controller.php?enews=';

const getBaseInfo = () => {
  return http.get(`${urlPrefix}base-info`);
};

const getList = (page: number, keyword?: string) => {
  return http.get(`${urlPrefix}vote-list`, {
    params: {
      page,
      search: keyword,
    },
  });
};

const getUserList = (data: any) => {
  return http.get(`${urlPrefix}user-list`, {
    params: {
      ...data,
    },
  });
};

const getDetail = (id: string) => {
  return http.get(`${urlPrefix}detail`, {
    params: {
      id,
    },
  });
};

const getRules = () => {
  return http.get(
   `${urlPrefix}rules`,
 );
};

const save = (data: any) => {
  const qsData = qs.stringify(data);
  return http.post(`${urlPrefix}save`, qsData);
};

const addShare = (id: string) => {
  return http.get(`${urlPrefix}addShare`, {
    params: {
      id,
    },
  });
};

const deleteData = (id: string) => {
  return http.get(`${urlPrefix}delete`, {
    params: {
      id,
    },
  });
};

export { getBaseInfo, getList, getDetail, getRules, getUserList, save, addShare, deleteData };
